import { render } from "./AuthenticatorAppSetupModal.vue?vue&type=template&id=6838197a&scoped=true"
import script from "./AuthenticatorAppSetupModal.vue?vue&type=script&lang=js"
export * from "./AuthenticatorAppSetupModal.vue?vue&type=script&lang=js"

import "./AuthenticatorAppSetupModal.vue?vue&type=style&index=0&id=6838197a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6838197a"]])

export default __exports__